module.exports = __webpack_public_path__ + "img/clear-night.f86c33c4.svg";